import {Component, OnInit} from '@angular/core';
import {NavParams, Platform} from "@ionic/angular";
import {TestScore} from "../../../types/interfaces";
import {SOCIAL_SHARE_TEXT, SOCIAL_SHARE_TEXT_VIBER, TEST_SHARE_TEXT, TEST_SHARE_TEXT_VIBER} from "../../constants";

@Component({
    selector: 'app-popover',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.scss'],
})
export class PopoverComponent implements OnInit {
    date: string = '';
    progress: number = 0;
    title: string = '';
    number: number = 0;
    test: boolean = false;
    testScore: number = 0;
    maxScore: number = 0;
    isSharePopover: boolean = false;
    isTestShare: boolean = false;
    refUrl: string = '';

    constructor(private navParams: NavParams,private platform: Platform) {
        this.date = this.navParams.data['date'];
        this.progress = this.navParams.data['progress'];
        this.title = this.navParams.data['title'];
        this.number = this.navParams.data['number'];
        this.test = this.navParams.data['test'];
        this.testScore = this.navParams.data['testScore'];
        this.maxScore = this.navParams.data['maxMark'];
        this.refUrl = this.navParams.data['refUrl'];

        this.isSharePopover = this.navParams.data['isSharePopover'];
        this.isTestShare = this.navParams.data['isTestShare'];
    }

    ngOnInit() {
    }

    shareViaTelegram(link: string) {
        let telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent( SOCIAL_SHARE_TEXT)}`;

        if ( this.isTestShare){
            telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent( TEST_SHARE_TEXT)}`;
        }

        window.open(telegramUrl, '_system');
    }

    shareViaViber(link: string) {
        let viberUrl = `viber://forward?text=${encodeURIComponent( SOCIAL_SHARE_TEXT_VIBER + link)}`;

        if ( this.isTestShare){
            viberUrl  = `viber://forward?text=${encodeURIComponent( TEST_SHARE_TEXT_VIBER + link)}`;
        }

        window.open(viberUrl, '_system');
    }

    shareViaFacebook(link: string) {
        let facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;

        window.open(facebookUrl, '_system');
    }

    shareViaFacebookMessenger(link: string) {

        // let messengerUrl = `https://www.facebook.com/dialog/share?link=${encodeURIComponent(link)}&app_id=1234567890`;
        // /https://www.facebook.com/dialog/share?link=https%3A%2F%2Fwww.youtube.com&app_id=1234567890


        let facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(link)}`;

        if (this.platform.is('mobile')) {
            facebookUrl = `fb-messenger://share?link=${encodeURIComponent(link)}`;
        }

        window.open(facebookUrl, '_system');
    }


}
